import styled from "styled-components";

export const Container = styled.form`
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.purple600};
    font-size: 24px;
    font-weight: 400;
    line-height: 33px;
    margin-bottom: 20px;
`;

export const EyeContainer = styled.div`
    margin-top: 6px;
    cursor: pointer;
`;
